import { SITE_URL, businessInfo } from '../config/seoConfig';

/**
 * Generate Product schema for campervan pages
 * @param {Object} vehicle - Vehicle data
 * @param {string} vehicle.name - Vehicle name (e.g., "Sun Catcher")
 * @param {string} vehicle.description - Vehicle description
 * @param {string} vehicle.image - Primary image URL
 * @param {string|number} vehicle.dailyRate - Daily rental rate
 * @param {string} vehicle.slug - URL slug (e.g., "campervan/sun-catchers")
 * @param {string} lang - Language code
 */
export const generateProductSchema = (vehicle, lang = 'en') => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: vehicle.name,
  description: vehicle.description,
  image: vehicle.image,
  brand: {
    '@type': 'Brand',
    name: 'SunCatchers',
  },
  category: 'Campervan Rental',
  offers: {
    '@type': 'Offer',
    priceCurrency: 'EUR',
    price: vehicle.dailyRate,
    priceValidUntil: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
    availability: 'https://schema.org/InStock',
    url: `${SITE_URL}/${lang}/${vehicle.slug}`,
    seller: {
      '@type': 'Organization',
      name: businessInfo.name,
    },
    itemCondition: 'https://schema.org/UsedCondition',
  },
  aggregateRating: vehicle.rating ? {
    '@type': 'AggregateRating',
    ratingValue: vehicle.rating,
    reviewCount: vehicle.reviewCount || 1,
  } : undefined,
});
